import type { FunctionComponent } from 'react';
import * as styles from './AfterConfirmText.module.css';

const AfterConfirmText: FunctionComponent = () => (
  <p className={styles.afterConfirmTextContainer}>Swap request sent!</p>
);

export default AfterConfirmText;
